import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppPlatforms } from '../enums/app-platforms.enum';
import { Provider } from '../models/provider.model';
import _ from 'lodash';
import { RequestService } from './request.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PatientService } from './patient.service';
import { isNativeApp, getAppPlatform } from 'src/app/util/app-platform';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {
  canTrackEvents?: boolean;
  settedProvider = false;
  platform = 'Web';
  sessionId = Date.now();

  constructor(
    private requestService: RequestService,
    private patientService: PatientService
  ) {}

  get appPlatform() {
    switch (getAppPlatform()) {
      case AppPlatforms.ANDROID:
        return 'Android';
      case AppPlatforms.IOS:
        return 'iOS';
      default:
        return 'Unknown';
    }
  }

  init(canInit: boolean): void {
    if (!canInit) {
      this.canTrackEvents = false;
      return;
    }

    if (isNativeApp()) this.platform = this.appPlatform;

    this.canTrackEvents = true;
  }

  public async showEvent(eventInput: string, eventProperties?: { [key: string]: unknown }) {
    try {
      const time = Date.now();
      const userId = this.patientService.getCaller()?.id || this.patientService.patient?.id

      await this.waitForInitialization();

      if (this.canTrackEvents === false) return;

      this.requestService
        .post(`/amplitude/track`, {
          eventInput,
          eventProperties,
          userId,
          eventOptions: {
            session_id: this.sessionId,
            platform: this.platform,
            app_version: environment.BITBUCKET_BUILD_NUMBER,
            time
          }
        })
        .then(() => {})
        .catch((error: HttpErrorResponse) => console.error(error));
    } catch (error) {
      console.error(error);
    }
  }

  public async setUser(provider: Provider) {
    try {
      await this.waitForInitialization();

      if (this.canTrackEvents === false) return;

      if (provider?.name && !this.settedProvider) {
        this.settedProvider = true;
        this.requestService
          .post(`/amplitude/provider`, {})
          .then(() => {})
          .catch((error: HttpErrorResponse) => {
            this.settedProvider = false;
            console.error(error);
          });
      }
    } catch (error) {
      console.error(error);
    }
  }

  private waitForInitialization() {
    if (!_.isUndefined(this.canTrackEvents)) return;

    return new Promise<void>((resolve, reject) => {
      const interval = setInterval(() => {
        if (!_.isUndefined(this.canTrackEvents)) {
          clearInterval(interval);
          resolve();
        }
      }, 200);

      // Timeout if 'isInitialized' doesn't have a value within 6 seconds
      setTimeout(() => {
        clearInterval(interval);
        reject();
      }, 6000);
    });
  }
}
